import { Box, Grid } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { DrawerWidget, ModalComponent } from '../../../../widgets';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import {
  allPlanEvaluacionAction,
  setActivoPlanEvaluacionAction,
} from './PlanEvaluacionAction';
import FiltrosPlanEvaluacionComponent from './components/FiltrosPlanEvaluacion';
import FormPlanEvaluacion from './components/FormPlanEvaluacion';
import ListadoPlanEvaluacion from './components/ListadoPlanEvaluacion';
import SettingsPlanEvaluacion from './components/SettingsPlanEvaluacion';
import TextFiltrosPlanEvaluacionComponent from './components/TextFiltrosPlanEvaluacion';

const PlanEvaluacionView = () => {
  const dispatch = Redux.useDispatch();

  const loginStore = Redux.useSelector((state) => state.login);
  const planEvaluacionStore = Redux.useSelector(
    (state) => state.planEvaluacion,
  );

  const [openModalForm, setOpenModalForm] = React.useState(false);

  const [drawer, setDrawer] = React.useState(0);

  React.useEffect(() => {
    const fetchData = async () => {
      if (
        (loginStore.isRoot || loginStore.isAdmin) &&
        planEvaluacionStore.all.length === 0
      ) {
        setDrawer(1);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function getViewsDrawer(value) {
    switch (value) {
      case 1:
        return <FiltrosPlanEvaluacionComponent />;
      case 2:
        return <SettingsPlanEvaluacion />;
      default:
        return null;
    }
  }

  return (
    <Grid container spacing={1}>
      <Grid
        item
        md={12}
        sx={{ display: 'flex', justifyContent: 'space-between' }}
      >
        <Box>
          <BotonComponent
            click={async () => {
              await setActivoPlanEvaluacionAction(dispatch, null);
              setOpenModalForm(true);
            }}
            green
            mr={2}
            addIcon
          />
          <BotonComponent
            click={async () => {
              await setActivoPlanEvaluacionAction(dispatch, null);
              await allPlanEvaluacionAction(
                dispatch,
                planEvaluacionStore.params,
              );
            }}
            disabled={
              planEvaluacionStore.loadingAll ||
              planEvaluacionStore.all.length === 0
            }
            white
            refreshIcon
            text={
              planEvaluacionStore.loadingAll ? 'Actualizando...' : 'Actualizar'
            }
          />
        </Box>
        <Box>
          <BotonComponent
            text="FILTROS"
            filterIcon
            click={() => setDrawer(1)}
            white
            mr={2}
          />
          <BotonComponent
            text="AJUSTES"
            settingsIcon
            blue
            click={() => setDrawer(2)}
          />
        </Box>
      </Grid>
      <Grid item md={12}>
        <TextFiltrosPlanEvaluacionComponent />
        <ListadoPlanEvaluacion setOpenModalForm={setOpenModalForm} />
      </Grid>
      <DrawerWidget
        open={drawer !== 0}
        onClose={(val) => setDrawer(!val ? 0 : val)}
      >
        {getViewsDrawer(drawer)}
      </DrawerWidget>
      <ModalComponent
        id="modalFormPlanEvaluacion"
        title={`${
          planEvaluacionStore.activo ? 'Editar' : 'Nuevo'
        } plan de evaluación`}
        open={openModalForm}
        maxWidth="md"
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        <FormPlanEvaluacion setOpenModalForm={setOpenModalForm} />
      </ModalComponent>
    </Grid>
  );
};

export default PlanEvaluacionView;
